import * as components from './components'

export default [
  {
    path: '/dashboard/admin',
    component: components.AdminDashboard,
    name: 'adminDashboard'
  },
  {
    path: '/dashboard/nunav/admin',
    component: components.NunavAdminDashboard,
    name: 'nunavAdminDashboard'
  },
  {
    path: '/dashboard/observer',
    component: components.ObserverDashboard,
    name: 'observerDashboard'
  },
  {
    path: '/dashboard/instructor',
    component: components.InstructorDashboard,
    name: 'instructorDashboard'
  },
  {
    path: '/dashboard/supervisor',
    component: components.SupervisorDashboard,
    name: 'supervisorDashboard'
  },
  {
    path: '/dashboard/student',
    component: components.StudentDashboard,
    name: 'studentDashboard',
    props: true
  },
  {
    path: '/dashboard/student/explore',
    component: components.StudentDashboardExplore,
    name: 'studentDashboardExplore',
    props: true
  },
  {
    path: '/dashboard/student/cn',
    component: components.ClearlyNextStudentDashboard,
    name: 'clearlyNextStudentDashboard',
    props: true
  },
  {
    path: '/dashboard/advisor',
    component: components.AdvisorDashboard,
    name: 'advisorDashboard'
  },
  {
    path: '/dashboard/coach',
    component: components.CoachDashboard,
    name: 'coachDashboard'
  },
  {
    path: '/dashboard/superAdmin',
    component: components.SuperAdminDashboard,
    name: 'superAdminDashboard'
  },
  {
    path: '/dashboard/recruiter',
    component: components.RecruiterDashboard,
    name: 'recruiterDashboard'
  },
  {
    path: '/dashboard/recruiter/report',
    component: components.RecruiterReport,
    name: 'recruiterReport'
  },
  {
    path: '/dashboard/prospective/student',
    component: components.ProspectiveStudentDashboard,
    name: 'prospectiveStudentDashboard',
    props: true
  },
  {
    path: '/dashboard/admitted/student',
    component: components.AdmittedStudentDashboard,
    name: 'admittedStudentDashboard',
    props: true
  },
  {
    path: '/dashboard/widget/admin',
    component: components.WidgetAdminDashboard,
    name: 'widgetAdminDashboard',
    props: true
  },
  {
    path: '/dashboard/widget/config',
    component: components.WidgetAdminDashboard,
    name: 'widgetConfiguraion',
    props: true
  },
  {
    path: '/dashboard/learner',
    component: components.LearnerDashboard,
    name: 'learnerDashboard',
    props: true
  },
  {
    path: '/dashboard/modern',
    component: components.ModernDashboard,
    name: 'modernDashboard',
    props: true
  },
  {
    path: '/learner/programs',
    component: components.LearnerProgramList,
    name: 'learnerProgramList',
    props: true
  },
  {
    path: '/learner/:uuid/profile',
    component: components.LearnerProfile,
    name: 'learnerProfile',
    props: true
  },
  {
    path: '/dashboard/selfRegistrationConfiguration/:uuid',
    component: components.SelfRegistrationConfiguration,
    name: 'selfRegistrationConfiguration',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/dashboard/routes.js